import useIsDisplayingChallengePortfolio from './useIsDisplayingChallengePortfolio';
import useSelectedMode from './useSelectedMode';

const navigation = {
  useIsDisplayingChallengePortfolio,
  useSelectedMode,
} as const;

export default navigation;
